import type {Code} from 'services/codelists/types';
import {CodeListRef} from 'schemas/references';

const validProductFormDetails: Array<Code['code']> = [
  CodeListRef['PRODUCT_FORM_DETAIL']['Flere måneder per side'],
  CodeListRef['PRODUCT_FORM_DETAIL']['En måned per side'],
  CodeListRef['PRODUCT_FORM_DETAIL']['Ei uke per side'],
  CodeListRef['PRODUCT_FORM_DETAIL']['En dag per side'],
  CodeListRef['PRODUCT_FORM_DETAIL']['Bordkalender'],
  CodeListRef['PRODUCT_FORM_DETAIL']['Veggkalender'],
  CodeListRef['PRODUCT_FORM_DETAIL']['Adventskalender'],
];

/*
Only allow these options for PC (Kalender):

P096 Flere måneder per side
P097 En måned per side
P098 Ei uke per side
P099 En dag per side
P101 Bordkalender
P106 Veggkalender
P108 Adventskalender
 */
export const isInvalidKalender = (
  code: Pick<Code, 'code'>,
  productForm: string,
): boolean => {
  // Ignore if productForm is not Kalender, as these restrictions only apply to those product forms.
  if (productForm !== CodeListRef['PRODUCT_FORM'].Kalender) {
    return false;
  }

  return !validProductFormDetails.includes(code.code);
};
